import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import numeral from 'numeral';
import { Map, GeoJSON } from 'react-leaflet';
import Control from 'react-leaflet-control';
import { Bar, HorizontalBar, Line } from 'react-chartjs-2';
import 'leaflet/dist/leaflet.css';

import BlankState from '../../components/BlankState';
import { DateRange, getDateRange } from '../../components/DateRange';
import Page from '../../components/Page';

import XLSX from 'xlsx';

import {
  loadMCIReports,
  loadGoodsReports,
  loadPolicyReports,
  loadSalesReports,
  loadMapReports,
  loadMapGeoJSON
} from '../../actions/reports';
import { getExcel } from './../../actions/policies';
import Utils from '../../utils/mci-utils';

const time_sections = {
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  YEARLY: 'yearly',
  SECTIONS: 'sections'
};

class Reports extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mci: {},
      policies: {},
      goods: {},
      sales: {},

      map_policies: [],
      geojson: {},
      active_country: {},

      filter: {
        type: time_sections.DAILY
      },
      date_range: '',
      generatingExcel: false
    };
  }

  componentDidMount() {
    this.buildReports();

    this.props.loadMapReports();
    this.props.loadMapGeoJSON();
  }

  componentWillReceiveProps(nextProps) {
    const {
      mci,
      policies,
      goods,
      sales,
      map_policies,
      geojson
    } = nextProps.reports;

    this.setState({ mci, policies, goods, sales, map_policies, geojson });
  }

  buildReports = () => {
    const { filter, date_range } = this.state;
    this.props.loadMCIReports(filter, date_range);
    this.props.loadGoodsReports(date_range);
    this.props.loadSalesReports(filter, date_range);
  };

  prepareChartData(collection) {
    let labels = [],
      data = [];

    const { filter } = this.state;

    for (let i in collection) {
      switch (filter.type) {
        case time_sections.DAILY:
          labels.push(collection[i].date);
          break;

        case time_sections.WEEKLY:
          labels.push(collection[i].date_from);
          break;

        case time_sections.MONTHLY:
          labels.push(collection[i].month_name);
          break;

        case time_sections.YEARLY:
          labels.push(collection[i].year);
          break;

        case time_sections.SECTIONS:
          labels.push(collection[i].section_name);
          break;

        default:
          labels.push(collection[i].date);
          break;
      }

      data.push(collection[i].count);
    }

    labels.reverse();
    data.reverse();

    return { labels, data };
  }

  buildMCIData(data) {
    const { collection } = data || {};

    let chartData = this.prepareChartData(collection);

    return {
      labels: chartData.labels,
      datasets: [
        {
          label: 'MCI Reports',
          data: chartData.data,
          borderColor: '#3cba9f',
          borderWidth: 2,
          fill: false
        }
      ]
    };
  }

  buildGoodsData(data) {
    console.log('goods', data);
    const { collection } = data || {};

    let labels = [],
      chart_data = [];

    for (let i in collection) {
      labels.push(collection[i].section_name);
      chart_data.push(collection[i].count);
    }

    labels.reverse();
    chart_data.reverse();

    return {
      labels,
      datasets: [
        {
          label: 'Goods Insured by Section',
          data: chart_data,
          backgroundColor: '#c45850',
          fill: true
        }
      ]
    };
  }

  buildSalesData(data) {
    const { collection } = data || {};

    let labels = [],
      chart_data = [];

    for (let i in collection) {
      // console.log('SALES', collection);

      if (this.state.filter.type === time_sections.WEEKLY) {
        labels.push(collection[i].date_from);
      } else if (this.state.filter.type === time_sections.MONTHLY) {
        labels.push(collection[i].month_name);
      } else {
        labels.push(collection[i].date);
      }

      chart_data.push(collection[i].totals.gross_direct_premium);
    }

    labels.reverse();
    chart_data.reverse();

    return {
      labels,
      datasets: [
        {
          label: 'Sales (TSh)',
          data: chart_data,
          backgroundColor: '#3e95cd',
          fill: true
        }
      ]
    };
  }

  toggleDatePicker = e => {
    this.setState({ show_custom_ranges: e.target.checked, show_picker: false });
  };
  onClickGetExcel = e => {
    this.setState({ generatingExcel: true });
    console.log(this.state.date_range);
    e.preventDefault();
    this.props
      .getExcel(this.state.date_range)
      .then(res => {
        this.setState({ generatingExcel: false });
        const data = res.value.data;
        const excelData = data.map(
          ({
            duration_of_cover,
            total_sum_insured,
            total_vat_duty,
            premium,
            policy_number,
            endorsement_number,
            date_created,
            start_date,
            cover_end_date,
            town_to,
            financier,
            insured_data: { name },
            currency_code,
            conveyance_name,
            order_number,
            created,
            insurer_policy_number,
            insurer_name,
            policy_status,
            policy_type,
            institute_cargo_clause,
            country_from_name,
            is_complete,
            intermediary_name
          }) => ({
            duration_of_cover,
            total_sum_insured,
            total_vat_duty,
            premium,
            policy_number,
            endorsement_number,
            date_created,
            start_date,
            cover_end_date,
            town_to,
            financier,
            name,
            currency_code,
            conveyance_name,
            order_number,
            created,
            insurer_policy_number,
            insurer_name,
            policy_status,
            policy_type,
            institute_cargo_clause,
            country_from_name,
            is_complete,
            intermediary_name
          })
        );

        let result = [];
        excelData.map(newData => {
          let fixed = {};
          const keys = Object.keys(newData);
          keys.map(key => {
            if (key === 'start_date') {
              return (fixed['START DATE'] = newData[key] = moment(
                newData[key]
              ).format('YYYY-MM-DD'));
            }
            if (key === 'created') {
              return (fixed['CREATED'] = newData[key] = moment(
                newData[key]
              ).format('YYYY-MM-DD'));
            }
            fixed[key.toUpperCase().replace(/_/g, ' ')] = newData[key];
          });
          result.push(fixed);
        });
        console.log(result);
        if (result.length > 0) {
          let wscols = [{ wch: 6 }, { wch: 7 }, { wch: 10 }, { wch: 20 }];

          let new_ws = XLSX.utils.json_to_sheet(result);
          new_ws['!cols'] = wscols;
          /* build workbook */
          let new_wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(new_wb, new_ws, 'Policies');

          /* write file and trigger a download */
          XLSX.writeFile(new_wb, 'sheetjs.xlsx', { bookSST: true });
        } else {
          alert('No data for that range');
        }
      })
      .catch(err => console.log(err));
  };

  onChange = e => {
    e.preventDefault();

    const { name, value } = e.target;

    this.setState(
      {
        filter: {
          [name]: value
        }
      },
      () => {
        this.buildReports();
      }
    );
  };
  onChangePicker = e => {
    console.log(e.target.name, e.target.value);
    let range = getDateRange(e.target.value);
  };
  onChangeDateRange = e => {
    // e.preventDefault();
    console.log(e.target.name, e.target.value);

    let range = getDateRange(e.target.value);

    if (range.hasOwnProperty('start_date')) {
      // Difference in days to determine range type to use
      let diff = moment(range.end_date).diff(moment(range.start_date), 'days'),
        filterType = time_sections.DAILY;

      if (diff <= 31) {
        filterType = time_sections.DAILY;
      } else if (diff > 31 && diff <= 93) {
        filterType = time_sections.WEEKLY;
      } else if (diff > 31 && diff <= 366) {
        filterType = time_sections.MONTHLY;
      }

      this.setState(
        {
          date_range: range,
          filter: { type: filterType }
        },
        () => {
          this.buildReports();
        }
      );
    }
  };

  onEachFeature = (feature, layer) => {
    layer.bindPopup(feature.properties.name);

    layer.on('mouseover', () => {
      layer.setStyle({
        fillColor: '#dae8f7'
      });

      this.setState({
        active_country: layer.feature.properties
      });
    });

    layer.on('mouseout', () => {
      layer.setStyle({
        fillColor: '#ddd'
      });
    });

    layer.on('click', () => {
      layer.setStyle({
        fillColor: '#dae8f7'
      });
    });
  };

  filterCountByCountry(map_policies, country) {
    let policy = map_policies.filter(policy => {
      return policy.country_code === country;
    });

    return policy.length > 0 ? policy[0].policy_count : 0;
  }

  render() {
    const mapProps = {
      position: [40, 80],
      zoom: 1.4
    };

    const geoJSONStyle = {
      color: '#bbb',
      fill: true,
      fillColor: '#ddd',
      fillOpacity: 1,
      weight: 1
    };

    const {
      filter,
      show_custom_ranges,
      mci,
      goods,
      sales,
      geojson,
      map_policies,
      active_country,
      generatingExcel
    } = this.state;

    const { mci_loading, goods_loading, sales_loading } = this.props.reports;

    const {
      today,
      last_7days,
      last_30days,
      last_3months,
      last_12months
    } = Utils.getTimeRanges();

    return (
      <Page isAdminPage={true} pageTitle="Reports">
        <div className="clearfix">
          <div className="btn-group clearfix">
            <label className="btn-radio">
              <input
                type="radio"
                name="range"
                value={today + ' - ' + today}
                onChange={this.onChangeDateRange}
                defaultChecked
              />
              <span>Today</span>
            </label>

            <label className="btn-radio">
              <input
                type="radio"
                name="range"
                value={last_7days}
                onChange={this.onChangeDateRange}
              />
              <span>Last 7 days</span>
            </label>

            <label className="btn-radio">
              <input
                type="radio"
                name="range"
                value={last_30days}
                onChange={this.onChangeDateRange}
              />
              <span>Last 30 days</span>
            </label>

            <label className="btn-radio">
              <input
                type="radio"
                name="range"
                value={last_3months}
                onChange={this.onChangeDateRange}
              />
              <span>Last 3 months</span>
            </label>

            <label className="btn-radio">
              <input
                type="radio"
                name="range"
                value={last_12months}
                onChange={this.onChangeDateRange}
              />
              <span>Last 12 months</span>
            </label>

            <label className="btn-radio" htmlFor="custom_range">
              <input
                type="radio"
                id="custom_range"
                name="range"
                onChange={this.toggleDatePicker}
              />
              <span>Custom</span>
            </label>
            <label className="btn-radio" style={{ margin: 30 }}>
              <button
                className="btn btn-warning"
                type="button"
                onClick={this.onClickGetExcel}
              >
                {generatingExcel ? 'Loading' : 'Get Excel'}
              </button>
            </label>
            <div className="clearfix">
              {show_custom_ranges ? (
                <DateRange
                  name="date_range"
                  onChange={this.onChangeDateRange}
                />
              ) : null}
            </div>
          </div>
          <div className="col-sm-4 col-md-3 hidden">
            <select
              name="type"
              className="form-control"
              onChange={this.onChange}
            >
              <option value="daily">Daily</option>
              <option value="weekly">Weekly</option>
              <option value="monthly">Monthly</option>
              <option value="yearly">Yearly</option>
              <option value="custom">Custom date range...</option>
            </select>
          </div>
        </div>

        <div
          className="card report-charts"
          style={{ height: '400px', overflow: 'hidden' }}
        >
          <BlankState
            data={false}
            isDataLoading={mci_loading}
            customMessage="Loading certificate reports"
          />

          <Line
            data={this.buildMCIData(mci)}
            height={360}
            options={{
              scales: {
                xAxes: [
                  {
                    ticks: {
                      callback: function(value, index, values) {
                        if (filter.type === time_sections.MONTHLY) {
                          return value;
                        } else {
                          return moment(value).format('MMM Do');
                        }
                      },
                      fixedStepSize: 50,
                      beginAtZero: true
                    }
                  }
                ],
                yAxes: [
                  {
                    ticks: {
                      beginAtZero: true,
                      callback: function(label, index, labels) {
                        if (Math.floor(label) === label) {
                          return numeral(label).format('0,0');
                        }
                      }
                    }
                  }
                ]
              },
              maintainAspectRatio: false
            }}
          />
        </div>

        <div
          className="card report-charts"
          style={{ height: '450px', overflow: 'hidden' }}
        >
          <BlankState
            data={false}
            isDataLoading={goods_loading}
            customMessage="Loading goods reports"
          />

          <HorizontalBar
            data={this.buildGoodsData(goods)}
            height={400}
            options={{
              scales: {
                xAxes: [
                  {
                    ticks: {
                      callback: function(value, index, values) {
                        return numeral(value).format('0,0');
                      },
                      beginAtZero: true
                    }
                  }
                ],
                yAxes: [
                  {
                    ticks: {
                      beginAtZero: true,
                      // fixedStepSize: 20,
                      callback: function(label, index, labels) {
                        let text = label.substring(0, 30) + '...';

                        return text;
                      }
                    }
                  }
                ]
              },
              responsive: true,
              maintainAspectRatio: false
            }}
          />
        </div>

        <div
          className="card report-charts"
          style={{ height: '400px', overflow: 'hidden' }}
        >
          <BlankState
            data={false}
            isDataLoading={sales_loading}
            customMessage="Loading sales reports"
          />

          <Bar
            data={this.buildSalesData(sales)}
            height={360}
            options={{
              scales: {
                xAxes: [
                  {
                    ticks: {
                      callback: function(value, index, values) {
                        if (filter.type === time_sections.MONTHLY) {
                          return value;
                        } else {
                          return moment(value).format('MMM Do');
                        }
                      },
                      fixedStepSize: 50,
                      beginAtZero: true
                    }
                  }
                ],
                yAxes: [
                  {
                    ticks: {
                      beginAtZero: true,
                      callback: function(label, index, labels) {
                        if (Math.floor(label) === label) {
                          return numeral(label).format('0,0');
                        }
                      }
                    }
                  }
                ]
              },
              maintainAspectRatio: false
            }}
          />
        </div>

        <div className="card">
          <Map
            center={mapProps.position}
            scrollWheelZoom={false}
            doubleClickZoom={false}
            zoomSnap={0.2}
            zoom={mapProps.zoom}
            style={{ background: '#fff', width: '100%', height: '35em' }}
          >
            {geojson.hasOwnProperty('features') ? (
              <GeoJSON
                data={geojson.features}
                style={geoJSONStyle}
                onEachFeature={this.onEachFeature}
              />
            ) : null}

            <Control position="topright">
              <div className="infobar">
                <h5>Policy Count per Country</h5>
                {active_country.hasOwnProperty('name') ? (
                  <div>
                    <span className="text-info text-uppercase">
                      {active_country.name}
                    </span>
                    <br />
                    {map_policies.length > 0 ? (
                      <h4>
                        {this.filterCountByCountry(
                          map_policies,
                          active_country.iso_code
                        )}
                      </h4>
                    ) : null}

                    {map_policies.length > 0 ? (
                      <ul className="hidden">
                        {map_policies.map((policy, index) => {
                          return (
                            <li key={index}>
                              {policy.country_code + ':' + policy.policy_count}
                            </li>
                          );
                        })}
                      </ul>
                    ) : null}
                  </div>
                ) : (
                  <span>Hover over a country to view policies</span>
                )}
              </div>
            </Control>
          </Map>
        </div>
      </Page>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.user,
  reports: state.reports
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      loadMCIReports,
      loadPolicyReports,
      loadGoodsReports,
      loadSalesReports,
      loadMapReports,
      loadMapGeoJSON,
      getExcel
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Reports);



// WEBPACK FOOTER //
// ./src/pages/dashboard/Reports.jsx